import { useResizablePanel } from '../useResizablePanel';
import { ResizablePanelHandle } from './ResizablePanelHandle';
import { PDFViewerPanel } from './WebEDIDocumentProperties/components/PDFViewerPanel/PDFViewerPanel';

type PDFReferenceSidebarProps = {
  pdfUrl: string;
  filename: string;
};

export const PDFReferenceSidebar = ({ pdfUrl, filename }: PDFReferenceSidebarProps) => {
  const { panelWidth, isCollapsed, handleMouseDown, expand, collapse, restoreNav } = useResizablePanel(true, {
    initialWidth: 50,
    minWidth: 50,
  });

  return (
    <aside
      className="relative flex flex-col border-l border-gray-200"
      style={{ width: panelWidth, height: `var(--content-height)` }}
    >
      <ResizablePanelHandle onMouseDown={handleMouseDown} />
      <PDFViewerPanel
        pdfUrl={pdfUrl}
        filename={filename}
        showDownload={false}
        showClose={!isCollapsed}
        collapsedLabel="PDF"
        onClose={() => {
          collapse();
          restoreNav();
        }}
        isCollapsed={isCollapsed}
        onExpand={expand}
      />
    </aside>
  );
};
